import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["centered", "children", "correctFootprint", "error", "id", "inverseOnBackground", "overflowEllipsisWidth", "rightAligned", "success", "UNSAFE_textProps", "warning", "white"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import useTextStyle from '@bubble-ui/hook-use-text-style';
import mapFeedbackState from '@bubble-ui/util-map-feedback-state';
import { ColorFunctions as Colors } from '@bubble-ui/particle-colors';
import { useDebugMode } from '@bubble-ui/provider-debug-mode';
import { platformSelect, isNative } from '@bubble-ui/util-platform';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import { isLiquorice } from '@bubble-ui/particle-design-versions';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import TextPrimitive from '@bubble-ui/primitive-text';
import useDeprecationWarning from '@bubble-ui/hook-use-deprecation-warning';
var getMargin = function getMargin() {
  var correctFootprint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return correctFootprint ? {
    marginTop: -5,
    marginBottom: -10
  } : {
    marginBottom: 0,
    marginTop: 0
  };
};
var TitleSubtitle = function TitleSubtitle(props) {
  useDeprecationWarning({
    componentName: 'TitleSubtitle',
    removalDate: 'v6.0.0',
    useInstead: 'Typography'
  });
  var centered = props.centered,
    children = props.children,
    correctFootprint = props.correctFootprint,
    error = props.error,
    id = props.id,
    inverseOnBackground = props.inverseOnBackground,
    overflowEllipsisWidth = props.overflowEllipsisWidth,
    rightAligned = props.rightAligned,
    success = props.success,
    UNSAFE_textProps = props.UNSAFE_textProps,
    warning = props.warning,
    white = props.white,
    restProps = _objectWithoutProperties(props, _excluded);
  var designVersion = useDesignVersion();

  // ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
  // Keep passing all props to the style sheet, even if we don't use them ourselves
  var styleOverride = useStyleSheet(TitleSubtitle, undefined, _objectSpread({
    designVersion: designVersion
  }, props));
  var debugMode = useDebugMode();
  var numberOfLines = overflowEllipsisWidth ? 1 : 0;
  var textStyle = useTextStyle({
    textToken: 'text-style/text/paragraphs/body/bold',
    align: rightAligned && 'right' || centered && 'center' || 'left',
    numberOfLines: numberOfLines,
    colorToken: mapFeedbackState({
      warning: warning,
      error: error,
      success: success,
      'inverse-on-background': inverseOnBackground,
      inverse: white
    })
  });
  return /*#__PURE__*/React.createElement(TextPrimitive, _extends({}, UNSAFE_textProps, {
    id: id,
    tag: "h3",
    numberOfLines: numberOfLines,
    style: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, textStyle), getMargin(correctFootprint)), platformSelect({
      web: {
        paddingBottom: 4,
        paddingTop: 1
      },
      ios: {
        paddingBottom: 5,
        paddingTop: 0
      },
      android: _objectSpread({
        paddingBottom: 5,
        paddingTop: 0
      }, isLiquorice(designVersion) ? {
        lineHeight: 20.5
      } : {})
    })), overflowEllipsisWidth ? _objectSpread({
      maxWidth: overflowEllipsisWidth
    }, isNative ? {} : {
      whiteSpace: 'nowrap',
      display: undefined
    }) : {}), {}, {
      textTransform: 'uppercase',
      backgroundColor: debugMode ? Colors.__backgroundSubtleInline().toString() : undefined
    }, styleOverride.textStyle), styleOverride.viewStyle)
  }, restProps), children);
};
TitleSubtitle.displayName = 'TitleSubtitle';
var OverridableTitleSubtitle = withProvisionalOverrideFromContext(TitleSubtitle);

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default OverridableTitleSubtitle;
//# sourceMappingURL=index.js.map